import { AccordionBodyItemView } from 'component/Accordion';
import { React, useEffect, useState } from 'react';
import { getCustomerById } from 'api/CustomersApi';

export const TaskCustomerView = (props) => {
  const [name, setName] = useState(null);
  const { formData, prefetchedName, subId } = props ?? {};
  const taskCustomerId = formData?.info?.general?.task_customer ?? formData?.task_customer;

  useEffect(() => {
    if (prefetchedName !== undefined) return;
    if (!taskCustomerId) return;
    getCustomerById(taskCustomerId)
      .then((res) => setName(res?.data?.name))
      .catch(() => setName(null));
  }, [taskCustomerId, prefetchedName]);

  return (
    <AccordionBodyItemView
      accordionSubId={subId ? <span>{subId}</span> : <span />}
      titleUA="Замовник задачі"
      titleEN="Task customer"
      children={prefetchedName ?? name ?? taskCustomerId ?? '-'}
    />
  );
};
